import numeral from "numeral";
import type { IDividendYieldDetails } from "types/graphqlTypes";

export default function getDividendYield(
  dividendYieldSnapshotEachSymbol: IDividendYieldDetails[],
  tickerSymbol: string,
) {
  if (dividendYieldSnapshotEachSymbol.length === 0) {
    return "-";
  }

  const [snapshot] = [...dividendYieldSnapshotEachSymbol].sort((a, b) => {
    if (a.tickerSymbol === tickerSymbol) {
      return -1;
    }
    if (b.tickerSymbol === tickerSymbol) {
      return 1;
    }
    return b.dividendYield - a.dividendYield;
  });

  const dividendYield = snapshot.dividendYield * 100;

  if (dividendYield < 0.1) {
    return numeral(dividendYield).format("0.00").replace(".00", "").replace(".", ",");
  }

  return numeral(dividendYield).format("0.0").replace(".0", "").replace(".", ",");
}
